import { render, staticRenderFns } from "./LoadingCustomerCard.vue?vue&type=template&id=344e66fe&scoped=true&"
import script from "./LoadingCustomerCard.vue?vue&type=script&lang=js&"
export * from "./LoadingCustomerCard.vue?vue&type=script&lang=js&"
import style0 from "./LoadingCustomerCard.vue?vue&type=style&index=0&id=344e66fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344e66fe",
  null
  
)

export default component.exports